/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Checkin_InvalidInputs */

const en_orders_checkin_invalid = /** @type {(inputs: Orders_Checkin_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check-in date/time is invalid.`)
};

const es_orders_checkin_invalid = /** @type {(inputs: Orders_Checkin_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La fecha y hora de entrada no es valida.`)
};

/**
* | output |
* | --- |
* | "Check-in date/time is invalid." |
*
* @param {Orders_Checkin_InvalidInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_checkin_invalid = /** @type {((inputs?: Orders_Checkin_InvalidInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Checkin_InvalidInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_checkin_invalid(inputs)
	return es_orders_checkin_invalid(inputs)
});